var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6921 0.78418H5.37015C2.45823 0.78418 0.0976562 3.269 0.0976562 6.33417V19.3047C0.0976562 22.3699 2.45823 24.8547 5.37015 24.8547H17.6921C20.604 24.8547 22.9646 22.3699 22.9646 19.3047V6.33417C22.9646 3.269 20.604 0.78418 17.6921 0.78418Z",
    fill: "#2D6CDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4946 5C7.41866 5 4.10352 8.48963 4.10352 12.7801C4.10352 14.8797 4.92737 16.9087 6.37011 18.3734V20.1701C6.37011 20.4398 6.49625 20.6971 6.70912 20.8506C6.84314 20.9502 7.00086 21 7.15849 21C7.2531 21 7.34376 20.9793 7.43443 20.9461L9.30684 20.2075C10.0203 20.4398 10.7575 20.5602 11.4946 20.5602C15.5705 20.5602 18.8857 17.0705 18.8857 12.7801C18.8857 8.48963 15.5705 5 11.4946 5ZM15.7479 11.0622L13.1975 14.5145C12.961 14.8382 12.5234 14.9295 12.1844 14.7261L9.9336 13.3693L7.76945 14.888C7.70638 14.9336 7.62754 14.9585 7.55265 14.9585C7.44621 14.9585 7.34373 14.9129 7.26489 14.8299C7.1348 14.6805 7.12298 14.4564 7.23729 14.2946L9.39352 11.2697C9.63003 10.9336 10.0715 10.8382 10.4145 11.0456L12.6535 12.39L15.2078 10.473C15.3655 10.3527 15.5863 10.3734 15.7203 10.5228C15.8582 10.6722 15.8662 10.9004 15.7479 11.0622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessanger);
export default __webpack_public_path__ + "static/media/Messanger.d27d51527d880497911a2b49fff90ae4.svg";
export { ForwardRef as ReactComponent };